export default __webpack_public_path__ + "static/media/product-11 (2).a49bce98.jpg";